import { createFocusTrap } from "focus-trap"

import Hook from "../utils/hook"

// The open modals, the topmost last. Deliberately shared by all `Modal`
// instances: a modal opened from another one (e.g. a picker's modal in a form
// modal) covers it, which stays in the DOM but is hidden visually until the
// one on top is closed, and only the topmost one is closed with Escape.
const openModals = []

export default Hook(`Modal`, {
  targets: [`inner`, `tabCatcher`],
  actions: [
    {
      name: `tabCatcherFocus`,
      target: `tabCatcher`,
      type: `focus`,
    },
    {
      name: `modalShow`,
      type: `modal:show`,
    },
    {
      name: `modalHide`,
      type: `modal:hide`,
    },
  ],

  focusTrap: null,
  windowKeydownHandler: null,

  mounted() {
    this.windowKeydownHandler = this.windowKeydown.bind(this)
    window.addEventListener(`keydown`, this.windowKeydownHandler)
  },

  destroyed() {
    window.removeEventListener(`keydown`, this.windowKeydownHandler)
    this.modalHideAction()
  },

  modalShowAction() {
    if (!openModals.includes(this)) {
      openModals.at(-1)?.cover()
      openModals.push(this)
    }

    window.clearTimeout(this.showTimeout)
    this.showTimeout = window.setTimeout(() => {
      if (!this.focusTrap) {
        // focus-trap pauses the trap of a covered modal and resumes it later
        this.focusTrap = createFocusTrap(this.el, { allowOutsideClick: true })
        this.focusTrap.activate()
      }
    }, 10)
  },

  modalHideAction() {
    const index = openModals.indexOf(this)

    if (index > -1) {
      openModals.splice(index, 1)
      this.uncover()
      // the closed modal was on top: the one it covered is back on top
      if (index === openModals.length) openModals.at(-1)?.uncover()
    }

    window.clearTimeout(this.showTimeout)
    this.focusTrap?.deactivate()
    this.focusTrap = null
  },

  cover() {
    this.classAdd(`is-covered`)
  },

  uncover() {
    this.classRemove(`is-covered`)
  },

  windowKeydown(e) {
    if (e.key !== `Escape` || openModals.at(-1) !== this) return

    this.js().exec(this.el.getAttribute(`data-modal-hide`))
  },

  tabCatcherFocusAction() {
    this.innerTarget.focus()
  },
})
